/* eslint-disable */
import jQuery from "jquery";
import Youtube from "../youtube";

(function($, window, document) {
  $.fn.videoControls = function() {
    return this.each(function(i, el) {
      const $trigger = $(el);
      const video = $trigger.data("id");
      let $iframe;

      if (video && $(`#${video}`).length) {
        // get our video if this has come from the play button
        $iframe = $(`#${video}`);
      }

      const Video = {
        play() {
          const player = $iframe.data("player");

          $iframe.closest(".video-frame").addClass("active");
          if (player && typeof player.playVideo !== "undefined") {
            player.playVideo();
          }
        },
        stop() {
          const player = $iframe.data("player");
          if (
            player &&
            typeof player.getPlayerState !== "undefined" &&
            player.getPlayerState() === 1
          ) {
            player.pauseVideo();
            player.stopVideo();
          }
          $iframe.closest(".video-frame").removeClass("active");
        }
      };

      $(this).data("videocontrols", Video);
    });
  };

  const player = {
    playVideo() {
      if (typeof YT === "undefined" || typeof YT.Player === "undefined") {
        window.onYouTubeIframeAPIReady = function() {
          player.bindEventHandlers();
        };

        $.getScript("//www.youtube.com/player_api");
      } else {
        player.bindEventHandlers();
      }
    },
    bindEventHandlers() {
      $(".play-icon").each(function() {
        player.loadPlayer(this);
      });

      $(".play-video").each(function() {
        $(this).videoControls();
      });
    },
    loadPlayer(el) {
      const videoID = $(el).data("id");
      let ytPlayer;

      ytPlayer = new YT.Player(videoID, {
        playerVars: {
          enablejsapi: 1,
          rel: 0,
          showinfo: 0,
          playsinline: 0,
          controls: 1,
          modestbranding: 1
        },
        videoId: videoID
      });
      $(`#${videoID}`).data("player", ytPlayer);
    }
  };

  if ($('.video-element').length > 0) {
    player.playVideo();
  }

  $('.video-thumbnail, .play-button').on('click', function (e) {
    e.preventDefault();
    $('.video-thumbnail').hide();

    const container = $(this).parent('.video-full').find('.aspect-ratio');
    const iframe = container.find('iframe');
    const url = iframe.attr('src');

    if (Youtube.canPlay(url)) {
      const player = new Youtube(iframe);
      // player.load();
      player.autoplay();
    }
    return;
  });

})(jQuery, window, document);

/* eslint-enable */
